import React from 'react';

const NavbarItem = ({ link, item, active = false }) => {
    return (
        <li className="nav-item">
            <a
                className={`nav-link${active ? ' is-active' : ''}`}
                href={link}
                aria-current={active ? 'true' : undefined}
            >
                {item}
            </a>
        </li>
    );
}

export default NavbarItem;
